import { FilesApi, FileShape } from '@cibo/core'
import { downloadAxiosResponse, intuitiveFromNow } from '@cibo/ui'
import DownloadIcon from '@mui/icons-material/Download'
import {
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import bytes from 'bytes'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const FilesTable = ({
  files,
  emptyMessage,
  disabled,
  FileAction,
}: {
  files?: FileShape[]
  emptyMessage?: string
  disabled?: boolean
  FileAction: ({ file }: { file: FileShape }) => ReactElement
}) => {
  const { t } = useTranslation(['@cibo/programs/DataEntryFileUpload'])

  const handleDownloadFile = useCallback((item: FileShape) => {
    FilesApi.downloadFile(item.id).then(downloadAxiosResponse(item.name))
  }, [])

  return (
    <>
      {!files?.length && (
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ fontStyle: 'italic' }}
        >
          {emptyMessage || t('noFilesAvailable')}
        </Typography>
      )}

      <Table>
        <TableBody>
          {files?.map((file, index) => (
            <TableRow key={index}>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography>{file.name}</Typography>

                  <Tooltip title={t('download', { filename: file.name })}>
                    <IconButton onClick={() => handleDownloadFile(file)}>
                      <DownloadIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </TableCell>
              <TableCell>{bytes.format(file.bytes)}</TableCell>
              <TableCell>{intuitiveFromNow(file.createdAt)}</TableCell>
              <TableCell>
                <FileAction file={file} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}
